<script>
  import Form from "./form.svelte"

  /**
   * The active Form component.
   * @type {import('./Form.svelte').FormComponent}
   */
  let activeComponent = Form
</script>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<!-- <div class="flex flex-col justify-between gap-3 mobile:flex-row mobile:items-center"> -->
<!-- <div class="text-lg font-semibold capitalize text-gray-800 md:text-xl">Document Metadata Details</div> -->
<!-- </div> -->
<div class="flex w-full flex-col {activeComponent == Form ? 'border-transparent' : 'border-[#a0a1a580]'} border-2 border-b-0">
  <svelte:component this={activeComponent} />
</div>
